<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
    <div class="container" fxLayout="column" fxLayoutAlign="center center">
        <div class="content" fxLayout="column" fxLayoutAlign="center center">
            <div class="error-code">404</div>

            <div class="message">Page not found</div>

            <div class="submessage">Sorry, the page you are looking for was either not found or does not exist.</div>

            <div class="submessage">
                Click <a class="back-link" href="javascript:void(0)" (click)="goBack()">here</a> to go back, or return to the <a class="back-link" [routerLink]="'/dashboard'">dashboard.</a> 
            </div>
            
            <div class="spacer"></div>
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/main/shared/components/errors/404/error-404.component.html